export default {
  overview: {
    title: "Zusätzliche Leistungs Übersicht",
    archive_title: "Archivierte Zusatzleistungen",
    subtitle: "Auflistung aller Zusätzlichen Leistungen.",
    actions: {
      create_new: "Neue Zusätzliche Leistung erstellen",
    },
    search: {
      placeholder: "bspw. Name",
    },
    table: {
      headers: {
        id: "ID",
        name: "Bezeichnung",
        unit: "Abrechnungseinheit",
        purchasePrice: "Realpreis",
        createdAt: "Erstellt am",
      },
      empty: {
        prices: "Nicht gesetzt",
      },
    },
  },
  detail: {
    title: "Zusätzliche Leistungs Details",
    actions: {
      update: "Speichern",
    },
    tabs: {
      general: "Allgemein",
      files: "Dateiablage",
      activity: "Protokoll",
    },
    form: {
      name: "Name",
      unit: "Einheit",
      purchasePrice: "Realpreis",
      purchaseUnit: "Realpreis Einheit",
      note: "Notizen",
      sections: {
        base_data: "Stammdaten",
        purchase: "Preis",
        note: "Notiz",
      },
    },
  },
  create: {
    title: "Zusätzliche Leistung Anlegen",
    subtitle: "Neue Zusätzliche Leistung anlegen.",
  },
  component: {
    autocomplete: {
      noDataText: "Zusätzliche Leistung nicht gefunden {value}",
    },
  },
}
